/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BackgroundEventsResult { 
    appointments: Array<any>;
    blockers: Array<any>;
}
export const BackgroundEventsResult_appointments_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BackgroundEventsResult_blockers_Validators: ValidatorFn[] =
    [  Validators.required, ];


